import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default from 'react';
import { IconWrapper } from './Icon.styles.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var Icon = function Icon(props) {
  var dataTestId = props['data-test-id'],
      color = props.color,
      secondaryColor = props.secondaryColor,
      style = props.style,
      className = props.className,
      svg = props.svg;
  return /*#__PURE__*/React__default.createElement(IconWrapper, {
    "data-test-id": dataTestId,
    color: color,
    secondaryColor: secondaryColor,
    style: _objectSpread({}, style),
    className: "icon ".concat(className)
  }, svg);
};
Icon.defaultProps = {
  className: '',
  color: 'currentColor'
};

export { Icon };
//# sourceMappingURL=Icon.js.map
